import { useTranslation } from 'react-i18next';

import { stepsData } from './helpers';
import { StepsSection } from '@/components/StepsSection';

export const HowToWinSection = () => {
  const { t } = useTranslation('jackpot');

  return <StepsSection title={t('howToWin.title')} steps={stepsData} />;
};
